import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	columnHeader: {
		id: 'software.main.board-container.board.unscheduled-work-swimlanes-container.column-header',
		defaultMessage: 'Drag issues to schedule',
		description:
			'Column header at the top of a column of cards which have not been scheduled in the users program board',
	},
	closeColumnLabel: {
		id: 'software.main.board-container.board.unscheduled-work-swimlanes-container.close-column-label',
		defaultMessage: 'Hide unscheduled work',
		description:
			'Label for a button on the unplanned work column in a program board which hides the column',
	},
	columnHeaderIssueTermRefresh: {
		id: 'software.main.board-container.board.unscheduled-work-swimlanes-container.column-header-issue-term-refresh',
		defaultMessage: 'Drag work items to schedule',
		description:
			'Column header at the top of a column of cards which have not been scheduled in the users program board',
	},
	filterIssuesHelpLink: {
		id: 'software.main.board-container.board.unscheduled-work-swimlanes-container.filter-issues-help-link',
		defaultMessage: 'Too many issues?',
		description: 'Help link to learn more about filtering issues',
	},
	filterIssuesHelpLinkIssueTermRefresh: {
		id: 'software.main.board-container.board.unscheduled-work-swimlanes-container.filter-issues-help-link-issue-term-refresh',
		defaultMessage: 'Too many work items?',
		description: 'Help link to learn more about filtering work items',
	},
});
